import { useTermApi } from "./useTerm.api";

export const { useGetTermsByCompanyQuery, useGetTermsUserByCompanyQuery, useSaveTermMutation, useDeleteTermMutation } = useTermApi;
